const UPDATE_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_LIST = 'UPDATE_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_LIST';
const RESET_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_COUNT = 'RESET_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_COUNT';
export const initialState = null;
/**
 * データを設定
 * @param data データ
 */
export const updateRfpCliFileViewRequestDataAction = (data) => ({
    payload: {
        data,
    },
    type: UPDATE_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_LIST,
});
/**
 * 未読件数をリセット
 * @param viewRequestId 閲覧申請ID
 */
export const resetRfpCliFileViewRequestCountAction = (viewRequestId) => ({
    payload: {
        viewRequestId,
    },
    type: RESET_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_COUNT,
});
/**
 * reducer処理
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
    switch (action.type) {
        case UPDATE_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_LIST:
            // API実行の戻り値を設定
            return action.payload.data;
        case RESET_RFP_CLIENT_ONE_FILE_ONE_VIEW_REQUEST_COUNT:
            if (state === null) {
                // データが存在しない場合は何もしない
                return state;
            }
            // 対応する閲覧申請の未読件数を0にする
            return state.map((item) => item.id === action.payload.viewRequestId
                ? Object.assign(Object.assign({}, item), { hasUnAnswer: false, unReadCount: 0 }) : item);
        default:
            return state;
    }
};
